import Axios from 'utils/axios'

export default {
	namespaced: true,
	state:{
		list: [],
		condition:{},
		page: 1,
		pageSize: 10,
		total: 1
	},
	mutations: {
		update(state, payload){
			Object.assign(state, payload)
		}
	},
	actions: {
		fetch({commit, state}){
			const promise = Axios.get('/admin/template/list', {
				params:{
					...state.condition,
					page: state.page,
					pageSize: state.pageSize
				}
			})
			promise.then(function (res) {
				commit('update', {
					list: res.list||[],
					total: res.total || 0
				})
			})
			return promise
		},
		fetchMore({commit, state}){
			const promise = Axios.get('/admin/template/list', {
				params:{
					...state.condition,
					page: state.page,
					pageSize: state.pageSize
				}
			})
			promise.then(function (res) {
				commit('update', {
					list: state.list.concat(res.list||[]),
					total: res.total || 0
				})
			})
			return promise
		},
		fetchOne({commit, state}, {ids}){
			const promise = Axios.get('/admin/template/listDetail', {
				params:{
					ids
				}
			})
			return promise
		},
		save({commit, state}, payload){
			return Axios.post('/admin/template/save', payload)
		},
		delete({commit, state}, {id}){
			return Axios.post('/admin/template/deleteTemplate', {
				id
			})
		}
	}
}
